import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { MenuOutlined } from '@ant-design/icons';

import UserStore from 'stores/UserStore';
import UIStore from '@/stores/UIStore';

import ChatBox from 'components/ChatBox/ChatBox.components';
import Logo from 'components/common/Logo';
import ContactSwitcher from 'components/ContactSwitcher/ContactSwitcher';
import HeaderLinks from './HeaderLinks';

const PortalHeader: React.FC = () => {
    const [showVirtualChat, setShowVirtualChat] = useState(false);
    const { pathname } = useLocation();

    // Close mobile nav on route change
    useEffect(() => {
        if (UIStore.isMobileNavOpen) {
            UIStore.onMobileNavToggle(false);
        }
    }, [pathname]);

    const handleMobileToggle = () => {
        UIStore.onMobileNavToggle(!UIStore.isMobileNavOpen);
    };

    return (
        <>
            <header
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0 16px',
                    height: 64,
                    background: '#fff',
                    boxShadow: '0 1px 4px -1px rgba(0,0,0,.15)',
                    zIndex: 10,
                }}
            >
                {/* LEFT */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    {/* Mobile menu */}
                    <div
                        className="d-block d-xl-none"
                        onClick={handleMobileToggle}
                        style={{ cursor: 'pointer', padding: '0 8px' }}
                    >
                        <MenuOutlined style={{ fontSize: 18 }} />
                    </div>

                    {/* Logo */}
                    <a
                        href={UserStore.isAuthenticated ? '/my-account' : 'https://parts-badger.com'}
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <Logo style={{ maxHeight: 40 }} />
                    </a>
                </div>

                {/* RIGHT */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    {UserStore.isAuthenticated && UserStore.isStaff && (
                        <div className="d-none d-xl-block" style={{ width: 300 }}>
                            <ContactSwitcher />
                        </div>
                    )}

                    <div className="d-none d-md-flex" style={{ alignItems: 'center', gap: 8 }}>
                        <HeaderLinks />
                    </div>
                </div>
            </header>

            <ChatBox visible={showVirtualChat} handleClose={() => setShowVirtualChat(false)} />
        </>
    );
};

export default observer(PortalHeader);
